const CookieConsentModule = {
  namespaced: true,
  state: {
    necessary: true,
    performance: false,
    advertising: false
  },
  mutations: {
    SET_NECESSARY_COOKIE(state) {
      state.necessary = true /** ไม่สามารถตั้งค่าเป็น False ได้ */
    },
    SET_PERFORMANCE_COOKIE(state, checked) {
      state.performance = checked
    },
    SET_ADVERTISING_COOKIE(state, checked) {
      state.advertising = checked
    }
  },
  actions: {
    setAcceptAll({ commit }) {
      commit('SET_NECESSARY_COOKIE', true)
      commit('SET_PERFORMANCE_COOKIE', true)
      commit('SET_ADVERTISING_COOKIE', true)
    },
    setAcceptPerformance({ commit }, checked) {
      commit('SET_PERFORMANCE_COOKIE', checked)
    },
    setAcceptAdvertising({ commit }, checked) {
      commit('SET_ADVERTISING_COOKIE', checked)
    }
  },
  getters: {
    isAcceptAll(state) {
      return state.necessary && state.performance && state.advertising
    }
  }
}

export default CookieConsentModule
